export default __webpack_public_path__ + "static/media/jupi2.3031e035.png";